import { ColProps as AntdColProps } from "antd";

export type ColProps = AntdColProps & {};

type DefaultColProps = {};

export const defaultProps: DefaultColProps = {};
